/**
 * Fetcher & mutator pure functions untuk store domain (products + cart).
 *
 * Catatan: endpoint orders.vue (transaction list) sebenarnya hit
 * /api/v1/transaction/... bukan /api/v1/store. File ini fokus pada /api/v1/store
 * (product CRUD) dan /api/v1/cart (keranjang).
 */
import http from "@/config/http";

/* ============================================================
 * Products (store)
 * ============================================================ */

export async function fetchProducts(params = {}) {
  const { data } = await http.get("/api/v1/store", { params });
  return data;
}

export async function fetchProductById(id) {
  const { data } = await http.get(`/api/v1/store/get/${id}`);
  return data;
}

export async function createProduct(payload) {
  const { data } = await http.post("/api/v1/store/create", payload);
  return data;
}

export async function updateProduct({ id, payload }) {
  const { data } = await http.put(`/api/v1/store/update/${id}`, payload);
  return data;
}

export async function deleteProduct(id) {
  const { data } = await http.delete(`/api/v1/store/delete/${id}`);
  return data;
}

/* ============================================================
 * Store Products (alias semantik — list /api/v1/store)
 * ============================================================ */

export async function fetchStoreProducts(params = {}) {
  const { data } = await http.get("/api/v1/store", { params });
  return data;
}

/* ============================================================
 * Store Orders (transactions yang hit /api/v1/orders)
 * ============================================================ */

export async function fetchStoreOrders(params = {}) {
  const { data } = await http.get("/api/v1/orders", { params });
  return data;
}

/* ============================================================
 * Cart
 * ============================================================ */

export async function fetchCart() {
  const { data } = await http.get("/api/v1/cart");
  return data;
}

export async function createCartItem(payload) {
  const { data } = await http.post("/api/v1/cart/create", payload);
  return data;
}

export async function updateCartItem(payload) {
  const { data } = await http.put("/api/v1/cart/update-cart", payload);
  return data;
}

export async function decrementCartItem(payload) {
  const { data } = await http.put("/api/v1/cart/update-cart-min", payload);
  return data;
}

export async function removeCartItem(payload) {
  const { data } = await http.put("/api/v1/cart/remove-cart", payload);
  return data;
}
